const uuidOperations = require('packages/identifiers/uuid')

module.exports = {
    ...uuidOperations,
}
